import axios from "axios";
import { getApiBase } from "@iliotech/watchlist-api/src/utils/watchlist-api";
import useSWR, { SWRResponse } from "swr";
import { InstrumentSummaryDetailed } from "../types";

type Environment = "dev" | "mock" | "prod" | "stage" | "test";

export const fetchInstrumentSummaryDetailed = async (
  environment: Environment,
  instrumentId: string,
  token: string,
  watchlistId?: string,
  fromDate?: string
) => {
  const INSIGHTS_API_BASE = getApiBase(environment);
  const url = `${INSIGHTS_API_BASE}/instrumentSummary?instrumentid=${instrumentId}&watchlistid=${watchlistId}&fromDate=${fromDate}`;
  const result = await axios.get<InstrumentSummaryDetailed>(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return result?.data || [];
};

export const useInstrumentSummaryDetailed = (
  environment: Environment = "dev",
  instrumentId: string,
  token: string,
  watchlistId: string,
  fromDate?: string
): SWRResponse<InstrumentSummaryDetailed> => {
  const { data, ...query } = useSWR<InstrumentSummaryDetailed>(
    [
      "instrument-summary-detailed",
      instrumentId,
      environment,
      token,
      watchlistId,
      fromDate,
    ],
    () =>
      fetchInstrumentSummaryDetailed(
        environment,
        instrumentId,
        token,
        watchlistId,
        fromDate
      ),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      refreshInterval: 1000 * 60 * 60 * 4, // 4 hours
      // revalidateOnMount: false,
    }
  );

  return {
    ...query,
    data,
  };
};
